// src/state/atoms.js
import { atom } from "jotai";

export const searchStringAtom = atom("");
export const registrationAtom = atom();
export const publicationsAtom = atom([]);
export const loadingRegAtom = atom(false);
export const loadingPubsAtom = atom(false);
export const loadingResultsAtom = atom({});
export const errorAtom = atom();
export const resultsAtom = atom({});
export const modelAtom = atom("gpt-5-mini-2025-08-07");
export const reasoningAtom = atom("minimal");
